export type ResourcesTab = 'restrictions' | 'cnc'

export interface ResourcesNavigationItem {
  id: ResourcesTab
  icon: string
  path: string
  translationKey: string
}

export const RESOURCES_NAVIGATION: ResourcesNavigationItem[] = [
  {
    id: 'restrictions',
    icon: 'icon-restricciones_recurso',
    path: '/resources/restrictions',
    translationKey: 'NAVIGATION:ResourcesRestrictions',
  },
  {
    id: 'cnc',
    icon: 'icon-cnc_recurso',
    path: '/resources/cnc',
    translationKey: 'NAVIGATION:ResourcesCNC',
  },
]
